import SaveToShortlistButton from '@bridebook/web/app-basic/components/save-to-shortlist-button';
import CallButton from '@bridebook/web/app-basic/components/supplier/sections/sticky-brochure-request/call-button';
import ToggleEnquiryFormButton from '@bridebook/web/app-basic/components/supplier/toggle-enquiry-form-button';
import { getSupplier } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { FC, useCallback } from 'react';
import { Box } from '@bridebook/ui';
import styles from './brochure-request.style';

const BrochureRequest: FC = () => {
  const supplier = useSelector(getSupplier);
  const noop = useCallback(() => undefined, []);

  if (!supplier) return null;

  return (
    <Box style={styles.container}>
      <Box style={styles.buttonWrap}>
        <Box style={styles.buttonContainer}>
          <ToggleEnquiryFormButton
            contactMethod="supplierProfile_stickyBottomBar"
            styleButton={styles.button}
            size="normal"
          />
        </Box>
        <Box style={styles.socialWrapper}>
          <CallButton />
          <SaveToShortlistButton
            supplierId={supplier.id}
            toggle={noop}
            variantSize="standard"
            clickedSection="stickyBottomBar"
          />
        </Box>
      </Box>
    </Box>
  );
};
export default BrochureRequest;
